import React from "react";
import { push } from 'react-router-redux';
import { store } from '../../store/store';
import { connect } from 'react-redux';
import MobileWrapper from '../../layouts/MobileWrapper';

import { Grid } from 'antd-mobile';



class MobileApplicationCenter extends React.Component {

	render() {

        const { mobileUserInfo } = this.props.user
        let navList = [], i=0;
        if(mobileUserInfo && mobileUserInfo.Menus.length !== 0){
            mobileUserInfo.Menus.forEach(v=>{
                if(v.icon === "application" && v.children.length !== 0){
                    v.children.forEach(list=>{
                        navList[i]={
                            icon: (<span className={list.icon} />),
                            text: list.name,
                            path: list.path
                        }
                        i++;
                    })
                }
            })
        }
        // const dailyItems = [
        //     {icon: (<span className="fa fa-clock-o fa-2x" />),   text: "加班申请" , path: '/mobile/mobile-apply-overtime-list'},
        //     {icon: (<span className="fa fa-history fa-2x" />),   text: "调休申请" , path: '/mobile/mobile-apply-break-down-list'   },
        //     {icon: (<span className="fa fa-sign-out fa-2x" />),   text: "请假申请" , path: '/mobile/mobile-apply-leave-list' },
        //     {icon: (<span className="fa fa-car fa-2x" />),  text: "外出申请" , path: '/mobile/mobile-apply-go-out-list'},
        //     {icon: (<span className="fa fa-briefcase fa-2x" />),  path: '/mobile/mobile-apply-business-list',   text: "出差申请"}
        // ]


        return  <div>
                    <div className="sub-title">考勤请假 </div>
                    <Grid data={navList} activeStyle={true} hasLine={false} onClick={_el =>store.dispatch(push(_el.path))}  />
                </div>


	}
}

// export default MobileWrapper(MobileApplicationCenter);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileApplicationCenter));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApplicationCenter.js